const layouts = [
  {
    id: 'passo-1',
  },
  {
    id: 'passo-2',
  },
  {
    id: 'passo-3',
  },
  {
    id: 'passo-4',
  },
  {
    id: 'passo-5',
  },
  {
    id: 'passo-6',
  },
  {
    id: 'passo-7',
  },
  {
    id: 'passo-8',
  },
  {
    id: 'passo-9',
  },
  {
    id: 'passo-10',
  },
  {
    id: 'passo-11',
  },
]

module.exports = layouts
